var render = function render(){
  var _vm$estimatedDti, _vm$estimatedDti2, _vm$estimatedDti2$ext, _vm$income;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header-block"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Orientačný limit úveru podľa DTI")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti = _vm.estimatedDti) === null || _vm$estimatedDti === void 0 ? void 0 : _vm$estimatedDti.value)) + " EUR")])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Akceptovaný príjem / mes.")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti2 = _vm.estimatedDti) === null || _vm$estimatedDti2 === void 0 ? void 0 : (_vm$estimatedDti2$ext = _vm$estimatedDti2.extra) === null || _vm$estimatedDti2$ext === void 0 ? void 0 : _vm$estimatedDti2$ext.prijem_mo)) + " EUR")])], 1)]), (_vm$income = _vm.income) !== null && _vm$income !== void 0 && _vm$income.error ? _c('div', [_c('br'), _vm._l(_vm.income.error, function (error, key) {
    return _c('div', {
      key: key,
      staticClass: "error-text"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  })], 2) : _vm._e()]), _vm._m(0), _c('form', {
    attrs: {
      "id": "income-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveIncome.apply(null, arguments);
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.zdanenie_minuly_rok,
      expression: "form.zdanenie_minuly_rok"
    }],
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.form.zdanenie_minuly_rok
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "zdanenie_minuly_rok", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "dropdown-input-custom rest-input required"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'zdanenie_minuly_rok',
      "init-value": _vm.form.zdanenie_minuly_rok,
      "options": _vm.booleanForm,
      "normal": "",
      "name": 'Bol príjem zdanený?'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'zdanenie_minuly_rok');
      }
    }
  })], 1), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "trzby"
    }
  }, [_vm._v("Ročné tržby / obrat")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.minulorocny_obrat,
      expression: "form.minulorocny_obrat",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "name": "trzby",
      "data-name": "trzby",
      "id": "trzby",
      "required": ""
    },
    domProps: {
      "value": _vm.form.minulorocny_obrat
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "minulorocny_obrat", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm._m(1), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "zisk"
    }
  }, [_vm._v("Zisk po zdanení")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.zisk_sro,
      expression: "form.zisk_sro",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "name": "zisk",
      "data-name": "zisk",
      "id": "zisk",
      "required": ""
    },
    domProps: {
      "value": _vm.form.zisk_sro
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "zisk_sro", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm._m(2), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vyplateny-zisk"
    }
  }, [_vm._v("Z toho zisk vyplatený na účet")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.zisk_sro_vyplateny,
      expression: "form.zisk_sro_vyplateny",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "name": "vyplateny-zisk",
      "data-name": "vyplateny-zisk",
      "id": "vyplateny-zisk",
      "required": ""
    },
    domProps: {
      "value": _vm.form.zisk_sro_vyplateny
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "zisk_sro_vyplateny", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm._m(3), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.podiel_v_sro,
      expression: "form.podiel_v_sro",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "name": "podiel",
      "min": "0",
      "max": "100",
      "data-name": "Podiel",
      "id": "Podiel",
      "required": ""
    },
    domProps: {
      "value": _vm.form.podiel_v_sro
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "podiel_v_sro", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm._m(5), _c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "text-small light"
  }, [_vm._v("O spoločnosti")]), _c('div', {
    staticClass: "text-small light"
  }, [_vm._v(" údaje overíte na "), _c('a', {
    "class": [_vm.ico ? 'link pointer' : 'link pointer noselect'],
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.navigateToFinstat.apply(null, arguments);
      }
    }
  }, [_vm._v(" finstat.sk ")])])]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.ico,
      expression: "ico"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "minlength": "8",
      "name": "icoZamestnavatel",
      "data-name": "Typ Pr Jmu 2",
      "placeholder": "",
      "id": "Typ-pr-jmu-2"
    },
    domProps: {
      "value": _vm.ico
    },
    on: {
      "change": _vm.initializeEmployerByIco,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.ico = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "obchodny-nazov"
    }
  }, [_vm._v("Obchodný názov")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.employerDetail.name,
      expression: "employerDetail.name"
    }],
    staticClass: "input-color-disabled text-input w-input",
    attrs: {
      "readonly": "",
      "type": "text",
      "maxlength": "256",
      "name": "obchodny-nazov",
      "data-name": "obchodny-nazov",
      "placeholder": "",
      "id": "obchodny-nazov"
    },
    domProps: {
      "value": _vm.employerDetail.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.employerDetail, "name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Sídlo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.employerDetail.slovensko_digital_response.formatted_address,
      expression: "employerDetail.slovensko_digital_response.formatted_address"
    }],
    staticClass: "input-color-disabled text-input w-input",
    attrs: {
      "readonly": "",
      "type": "text",
      "maxlength": "256",
      "name": "sidlo",
      "data-name": "sidlo",
      "placeholder": "",
      "id": "sidlo"
    },
    domProps: {
      "value": _vm.employerDetail.slovensko_digital_response.formatted_address
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.employerDetail.slovensko_digital_response, "formatted_address", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Dátum vzniku")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.podnikanieOd,
      expression: "form.podnikanieOd"
    }],
    staticClass: "input-color text-input w-input required",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": _vm.form.podnikanieOd
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "podnikanieOd", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "dropdown-input-custom rest-input required"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'sro_odvetvie',
      "init-value": _vm.form.odvetvie,
      "options": _vm.formTemplate.zamestnavatel_odvetvie.choices,
      "normal": "",
      "name": 'Odvetvie',
      "required": ""
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'odvetvie');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'sro_komora',
      "init-value": _vm.form.komora,
      "options": _vm.formTemplate.komora.choices,
      "normal": "",
      "name": 'Komora'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'komora');
      }
    }
  })], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "light"
  }, [_vm._v(" Údaje pre výpočet príjmu zadávajte za posledné ukončené účtovné obdobie, pričom účtovnú závierku spoločnosti môžete stiahnuť "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.registeruz.sk/cruz-public/domain/accountingentity/simplesearch",
      "target": "_blank"
    }
  }, [_vm._v("TU")]), _vm._v(".")]), _c('div', {
    staticClass: "form-source-note"
  }, [_vm._v(" V účtovnej závierke použite vždy stĺpec „bežné účtovné obdobie“. Riadok sa líši podľa toho, či ide o mikro účtovnú jednotku (Úč MÚJ) alebo závierku podnikateľov (Úč POD). ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "field-source"
  }, [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" Výkaz ziskov a strát, riadok 01. Pri Úč MÚJ 2-01 ide o „Výnosy z hospodárskej činnosti spolu“; pri Úč POD 2-01 o „Čistý obrat“. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "field-source"
  }, [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" Výkaz ziskov a strát → „Výsledok hospodárenia za účtovné obdobie po zdanení“: riadok 38 v Úč MÚJ 2-01 alebo riadok 61 v Úč POD 2-01. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "field-source"
  }, [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" tento údaj nie je priamo v účtovnej závierke. Zadajte sumu skutočne poukázanú žiadateľovi podľa rozhodnutia valného zhromaždenia a výpisu z jeho účtu. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Podiel"
    }
  }, [_vm._v("Podiel v spoločnosti"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "field-source"
  }, [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" výpis z obchodného registra alebo spoločenská zmluva – zadajte obchodný podiel žiadateľa v percentách. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Typ-pr-jmu-2"
    }
  }, [_vm._v("IČO "), _c('span', {
    staticClass: "pop-300"
  }, [_vm._v("(údaje sa doplnia automaticky)")])]);

}]

export { render, staticRenderFns }